module.exports = __webpack_public_path__ + "static/media/undraw_start_building_vqhd.9d81d3ce.png";